import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class AutoTagDialogService {
    dialogOpen$: Subject<any> = new Subject<any>();
}
